import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { PageHOC } from "Views/scaffolding/page";
import { Splash } from "Views/scaffolding/pages/splash";
import { v4 as uuid } from "uuid";

/** Props for rendering the routes. */
export type RoutesProps = {
  /** An array of possible routes. */
  routes: string[];
};

function mapRoutes(routes: RoutesProps["routes"]): React.ReactFragment {
  const mapped = routes.map(route => (
    <Route key={uuid()} path={route} exact={true} component={PageHOC} />
  ));
  mapped.push(
    <Route key={uuid()} path="/error" exact={true} component={PageHOC} />,
    <Route key={uuid()} component={Splash} />
  );
  return mapped;
}

function Routes(props: RoutesProps): JSX.Element {
  return (
    <BrowserRouter>
      <Switch>{mapRoutes(props.routes)}</Switch>
    </BrowserRouter>
  );
}

const routesMemo = React.memo<RoutesProps>(Routes);
export { routesMemo as Routes };
